import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UsuarioFranquiaRfariasListarModule } from "./usuario-franquia-rfarias-listar/usuario-franquia-rfarias-listar.module";
import { UsuarioFranquiaRfariasInserirModule } from "./usuario-franquia-rfarias-inserir/usuario-franquia-rfarias-inserir.module";
import { UsuarioFranquiaRfariasEditarModule } from "./usuario-franquia-rfarias-editar/usuario-franquia-rfarias-editar.module";
import { UsuarioFranquiaRfariasDetalharModule } from "./usuario-franquia-rfarias-detalhar/usuario-franquia-rfarias-detalhar.module";


@NgModule({
    imports: [
        CommonModule,     
        UsuarioFranquiaRfariasListarModule,
        UsuarioFranquiaRfariasInserirModule,
        UsuarioFranquiaRfariasEditarModule,
        UsuarioFranquiaRfariasDetalharModule
    ],
    exports: [ 
        UsuarioFranquiaRfariasListarModule,
        UsuarioFranquiaRfariasInserirModule,
        UsuarioFranquiaRfariasEditarModule,
        UsuarioFranquiaRfariasDetalharModule
    ]
})
export class UsuarioFranquiaRfariasAppModule { }
